<template>
	<v-chip
		variant="outlined"
		class="badge-muted copy-id-chip"
		data-test="build-id-value"
	>
		<span class="id-truncated">{{ formattedBuildID }}</span>
		<CopyToClipboardButton
			v-if="showClipboardButton"
			:value-to-copy="buildID"
			value-name="Build ID"
		/>
	</v-chip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CopyToClipboardButton from "@/components/Common/CopyToClipboardButton.vue";
import * as util from "@/js/utilities";

export default defineComponent({
	name: "BuildIDDisplay",
	components: {
		CopyToClipboardButton,
	},
	props: {
		buildID: { type: String },
		showClipboardButton: { type: Boolean, default: false },
	},
	computed: {
		formattedBuildID(): string {
			return this.buildID ? util.shortenID(this.buildID) : "";
		},
	},
});
</script>

<style scoped>
.id-truncated {
	white-space: nowrap;
}
</style>
